import styled from "styled-components";

const VerticalDivider = styled.div`
    width: 3px;
    height: 40%;
    background-color: rgb(180,180,180);
    margin-left: 30px;
    margin-right: 30px;
`

export default VerticalDivider;